import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketMachineResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketMachineUseCase = async (
  machineId: string,
  ticketId: string,
): Promise<PatchTicketMachineResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketMachine(
      namespace,
      ticketId,
      machineId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update ticket machine")
        .message,
    };
  }
};
